export default [
  {
    path: '/admin/promotions',
    name: 'promotion',
    meta: { requiresAuth: true },
    component: () => import('@/pages/promotion')
  },
  {
    path: '/admin/promotions/create',
    name: 'promotion-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/promotion/create')
  },
  {
    path: '/admin/promotions/:id/discount-edit',
    name: 'discount-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/promotion/discount-edit')
  },
  {
    path: '/admin/promotions/:id/free-item-per-amount-edit',
    name: 'free-item-per-amount-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/promotion/free-item-per-amount-edit')
  },
  {
    path: '/admin/promotions/:id/free-coin-edit',
    name: 'free-coin-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/promotion/free-coin-edit')
  },
  {
    path: '/admin/promotions/:id/buy-item-free-item-edit',
    name: 'buy-item-free-item-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/promotion/buy-item-free-item-edit')
  }
]